import { render } from "./Produkte_eigen_Handy.vue?vue&type=template&id=16a20946"
import script from "./Produkte_eigen_Handy.vue?vue&type=script&lang=js"
export * from "./Produkte_eigen_Handy.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\stfg.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__